import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom';

import { SidebarProps } from "./Sidebar.types";

import NavbarLogo from '../Navbar/assets/logo.svg';
import "./Sidebar.scss";

export const Sidebar: React.FC<SidebarProps> = ({ menu }) => {
  const { t } = useTranslation();
  const history = useHistory();
  return(
      <div className={"sidebar"}>
        <span className="sidebar-logo" onClick={() => history.push('/')}><img alt={t("proxibit_tag_plain")} src={NavbarLogo}/></span>
        {menu && menu.length > 0 &&
          <>
            {
              menu.map((item, index) => {
                return (
                    <div className={item.isActive ? `sidebar-menu-item sidebar-menu-item-active` : 'sidebar-menu-item'} onClick={() => item.clickAction()} key={index}>
                        {item.isActive ? <img src={item.iconactive}/> : <img src={item.icon}/>}
                    </div>
                );
              })
            }
          </>
        }
      </div>
  )
}

